import type { ReactNode } from "react";
import { routesConfig } from "config/app-config";
import CommandeCard from "components/molecules/cards/CommandeCard/CommandeCard";
import Statut from "constants/Statut";
import type Commande from "models/Commande";
import { useUser } from "@sdeapps/react-core";
import type { User } from "@sdeapps/react-core";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import type { StoreProps } from "store/store";
import { Masonry } from "@mui/lab";

interface CommandeListeProps {
  commandes: Array<Commande>;
  agents?: Array<User>;
  uri?: (id: string) => string;
  displayArticleListHeader?: boolean;
  displayCommentaires?: boolean;
  hasCommandeLink?: boolean;
}

function CommandeListe({
  commandes,
  agents,
  uri,
  displayArticleListHeader = false,
  displayCommentaires = false,
  hasCommandeLink = false,
}: Readonly<CommandeListeProps>): ReactNode {
  const { user } = useUser();
  const commandesStore = useSelector<StoreProps, { loadingCommandsIds: Array<string> }>(
    (state) => state?.commandes
  );

  const location = useLocation();

  if (agents != null && uri != null && location.pathname === routesConfig.validator.path) {
    return (
      <Masonry columns={{ xs: 1, lg: 2 }} spacing={4}>
        {commandes.map((commande) => (
          <CommandeCard
            key={commande.commandeId}
            commande={commande}
            agent={agents.find((u) => u.id === commande.demandeurId)}
            displayArticleListHeader={displayArticleListHeader}
            displayCommentaires={displayCommentaires}
            haveCardAction={commande.statutCommande === Statut.EN_ATTENTE}
            urlCardAction={
              hasCommandeLink && commande.statutCommande === Statut.EN_ATTENTE
                ? uri(commande.commandeId)
                : undefined
            }
            isLoading={commandesStore.loadingCommandsIds.includes(commande.commandeId)}
          />
        ))}
      </Masonry>
    );
  }

  return (
    <Masonry columns={{ xs: 1, lg: 2 }} spacing={4}>
      {commandes.map((commande) =>
        agents != null && uri != null ? (
          <CommandeCard
            key={commande.commandeId}
            commande={commande}
            agent={agents.find((u) => u.id === commande.demandeurId)}
            displayArticleListHeader={displayArticleListHeader}
            displayCommentaires={displayCommentaires}
            haveCardAction
            urlCardAction={hasCommandeLink ? uri(commande.commandeId) : undefined}
            isLoading={commandesStore.loadingCommandsIds.includes(commande.commandeId)}
          />
        ) : (
          <CommandeCard
            key={commande.commandeId}
            commande={commande}
            agent={user}
            displayArticleListHeader={displayArticleListHeader}
            displayCommentaires={displayCommentaires}
            isLoading={commandesStore.loadingCommandsIds.includes(commande.commandeId)}
          />
        )
      )}
    </Masonry>
  );
}

export default CommandeListe;
